/** Minha rota disponível em qualquer domínio. A visibilidade por profissional fica em lerMinhaRotaVisivel. */
export function dominioTemMinhaRota() {
	return true
}

const prefixo = "minhaRotaVisivel:"

function chave(idProf) {
	return prefixo + String(idProf ?? "")
}

export function lerMinhaRotaVisivel(idProf) {
	try {
		return window.localStorage.getItem(chave(idProf)) !== "0"
	} catch {
		return true
	}
}

export function salvarMinhaRotaVisivel(idProf, visivel) {
	try {
		window.localStorage.setItem(chave(idProf), visivel ? "1" : "0")
	} catch {
		/* ignore */
	}
}
